import { Badge, Divider } from "antd";
import { Link } from 'react-router-dom';
import "./index.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { isMobile } from "../../../../services/clientService";
import {getFirstName, getLastName} from '../../../../services/userService'
const Sidebar = props => {
    const location = useLocation();
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const { numOfSavedJobs } = useSelector(({ JobsReducer }) => JobsReducer);
    if (location.pathname.includes('onboarding')) return null;

    return (
        <div className="sidebar">
            <div className="top">
                <div className="logo-wrapper">
                    <img src="/logos/logo-genie-blue.png" className="logo" />
                </div>
                {/* {isMobile() ? null : <Divider />} */}
                <ul>
                    {[

                        { text: 'Resumes', url: '/' },
                        { text: `Job Tracker`, url: '/jobs' },
                        { text: 'AI Job Matching', url: '/search' },
                        { text: 'Settings', url: '/settings' },

                    ].map(item => <li key={item.url} className={location.pathname === item.url ? 'active' : ''}>
                        <Link to={item.url} onClick={() => props.onExit && props.onExit()}>
                            {item.text}
                        </Link>
                    </li>)}
                </ul>
            </div>
            {userDetails && <div className="bottom">
                <div className="username">{`${getFirstName(userDetails)} ${getLastName(userDetails)}`}</div>
                <div className="email">{userDetails.email}</div>
            </div>}


        </div>
    )
}

export default Sidebar;